import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import SubscriberCountFilter from './SubscriberCountFilter';

function SubscriberCountTable(props) {
    const {
        isLoading,
        columns,
        detailedColumns,
        dataList,
        detailedData,
        isFade,
        onFilterSubmit
    } = props;

    const [showDetailed, setShowDetailed] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});

    const ExpandedComponent = ({ data }) => (
        <div className='text-left th_data' style={{ 
            padding: '20px', 
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            margin: '10px 0'
        }}>
            {data.bearer_ids && data.bearer_ids.length > 0 ? (
                <>
                    <div className="row">
                        {data.bearer_ids.map((bearer, index) => (
                            <div key={index} className="col-lg-4 col-md-6 mb-2">
                                <div className="card border-left-primary" style={{ 
                                    borderLeft: '4px solid #2491e4',
                                    transition: 'transform 0.2s',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => e.target.closest('.card').style.transform = 'translateY(-2px)'}
                                onMouseLeave={(e) => e.target.closest('.card').style.transform = 'translateY(0)'}
                                >
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <small className="text-muted">Bearer ID</small>
                                                <div className="font-weight-bold" style={{ 
                                                    fontSize: '0.9rem',
                                                    color: '#2491e4',
                                                    fontFamily: 'monospace'
                                                }}>
                                                    {bearer.bearerId}
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <small className="text-muted">Count</small>
                                                <div className="h5 text-primary mb-0">
                                                    {bearer.count.toLocaleString()}
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="mt-2">
                                            <div className="progress" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar bg-primary" 
                                                    style={{ 
                                                        width: `${(bearer.count / data.count) * 100}%` 
                                                    }}
                                                ></div>
                                            </div>
                                            <small className="text-muted">
                                                {((bearer.count / data.count) * 100).toFixed(1)}% of total
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className="text-center py-4">
                    <i className="bx bx-info-circle text-muted" style={{ fontSize: '2rem' }}></i>
                    <p className="text-muted mt-2">No bearer ID data available for this date.</p>
                </div>
            )}
        </div>
    );

    const toggleView = () => {
        setShowDetailed(!showDetailed);
        setExpandedRows({});
    };

    const handleRowExpandToggled = (expanded, row) => {
        if (expanded) {
            setExpandedRows({ [row.date]: true });
        } else {
            setExpandedRows({});
        }
    };

    const isRowExpandable = (row) => {
        return row.bearer_ids && row.bearer_ids.length > 0;
    };

    const conditionalRowStyles = [
        {
            when: row => expandedRows[row.date],
            style: {
                backgroundColor: '#e3f2fd',
                borderLeft: '4px solid #2196f3',
            },
        },
        {
            when: row => isRowExpandable(row),
            style: {
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#f5f5f5',
                },
            },
        }
    ];

    return (
        <div className="App">
           

            <div className='mt-3'>
                {isLoading || isFade ?
                    <LoadingSpinner />
                    :
                    dataList.length > 0 ? (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h5 className="mb-0" style={{ width:200 }}>
                                        {showDetailed ? 'Detailed Bearer ID View' : 'Summary View'}
                                    </h5>
                                    {!showDetailed && (
                                        <small className="text-muted">
                                            Click on rows to expand details
                                        </small>
                                    )}
                                </div>
                                <button
                                    className="btn btn-primary"
                                    onClick={toggleView}
                                >
                                    {showDetailed ? 'Show Summary' : 'Show Detailed View'}
                                </button>
                            </div>

                            {!showDetailed ? (
                                <DataTable
                                    className="services_datatable users"
                                    columns={columns}
                                    data={dataList}
                                    highlightOnHover
                                    pagination
                                    paginationPerPage={20}
                                    paginationComponentOptions={{
                                        noRowsPerPage: true
                                    }}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                    expandOnRowClicked
                                    expandableRowsHideExpander={false}
                                    onRowExpandToggled={handleRowExpandToggled}
                                    expandableRowExpanded={row => expandedRows[row.date] || false}
                                    expandableRowDisabled={row => !isRowExpandable(row)}
                                    conditionalRowStyles={conditionalRowStyles}
                                    noDataComponent={
                                        <div className="text-center py-4">
                                            <p className="text-muted">No data available</p>
                                        </div>
                                    }
                                />
                            ) : (
                                <DataTable
                                    className="services_datatable users"
                                    columns={detailedColumns}
                                    data={detailedData}
                                    highlightOnHover
                                    pagination
                                    paginationPerPage={50}
                                    paginationComponentOptions={{
                                        noRowsPerPage: true
                                    }}
                                    noDataComponent={
                                        <div className="text-center py-4">
                                            <p className="text-muted">No detailed data available</p>
                                        </div>
                                    }
                                />
                            )}
                        </>
                    ) : (
                        <div className="card">
                            <div className="card-body text-center p-5">
                                <h5>No subscriber data to display</h5>
                                <p>Please select a date range, report type and click Filter to view data</p>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default SubscriberCountTable;